import React, { useContext, useState, useEffect } from 'react';
import styled from 'styled-components';
import TargetIcon from 'mdi-react/TargetIcon';
import { FaAustralSign } from 'react-icons/fa6';
import { Field, Form } from 'react-final-form';
import PropTypes from 'prop-types';
import { FormContainer, FormGroup, FormButtonToolbar } from '@/shared/components/form/FormElements';
import { colorGreen, colorWhite } from '@/utils/palette';
import { left, right } from '@/utils/directions';
import TextEditor from '@/shared/components/text-editor/TextEditor';
import { Button, Modal } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { AuthContext } from '../../../../../context/AuthContext';
import CopyrightAndSocialForm from './Footer';

const renderTextEditor = ({ input }) => <TextEditor {...input} />;

renderTextEditor.propTypes = {
  input: PropTypes.shape({}).isRequired,
};

const FooterInfo = () => {
  const [showFooterSettingModal, setShowFooterSettingModal] = useState(false);



  
  return (
    <div>
      <DashboardBookingMission>
        <FaAustralSign />
        <DashboardBookingMissionTitle>Footer</DashboardBookingMissionTitle>
        <DashboardBookingMissionDescription>
          <Button variant="link" onClick={() => setShowFooterSettingModal(true)}>
            Click here
          </Button>
          to change Footer Setting.
        </DashboardBookingMissionDescription>
      </DashboardBookingMission>

      <Modal
        show={showFooterSettingModal} 
        onHide={() => setShowFooterSettingModal(false)}
        centered
        size="md"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Footer Setting</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CopyrightAndSocialForm setShowFooterSettingModal={setShowFooterSettingModal} />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default FooterInfo;

// region STYLES
const DashboardBookingMission = styled.div`
  text-align: ${left};
  height: 108px;
  background: orange;
  border-radius: 5px;
  padding: 15px 13px;
  position: relative;
  overflow: hidden;

  svg {
    position: absolute;
    height: 80px;
    width: 80px;
    top: calc(50% - 40px);
    opacity: 0.3;
    ${right}: -23px;
    color: ${colorWhite};
  }
`;

const DashboardBookingMissionDescription = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 1.25;
  color: ${colorWhite};
  max-width: 100%;

  @media screen and (min-width: 376px) and (max-width: 991px) {
    max-width: calc(100% - 60px);
  }

  @media screen and (min-width: 1200px) and (max-width: 1550px) {
    font-size: 14px;
  }

  @media screen and (max-width: 420px) {
    font-size: 14px;
  }
`;

const DashboardBookingMissionTitle = styled.p`
  font-size: 24px;
  font-weight: 500;
  color: ${colorWhite};
  margin-top: 0;
  margin-bottom: 4px;
  line-height: 1.25;

  @media screen and (min-width: 1200px) and (max-width: 1399px) {
    font-size: 20px;
  }
`;
// endregion
